import { lightVariablesArr, sizeVariablesArr } from '../Water.variables';

const WaterLightTheme = {
  metadata: {
    id: 'water-light',
    name: { enUS: 'Water Light', ptBR: 'Water Light', esES: 'Water Light' },
    isDark: false,
  },
  colors: lightVariablesArr,
  sizes: sizeVariablesArr,
};

export { WaterLightTheme };
